import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var BrowserSearchSvg = function BrowserSearchSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.722 10.585a4 4 0 0 1 2.815-1.156c1.056 0 2.069.416 2.815 1.156a3.926 3.926 0 0 1 .475 5.016l1.864 1.849-1.048 1.039-1.864-1.848a4.004 4.004 0 0 1-5.057-.471 3.93 3.93 0 0 1-1.166-2.792c0-1.048.419-2.052 1.166-2.793m2.815.313a2.5 2.5 0 0 0-1.768.726 2.47 2.47 0 0 0 0 3.507 2.51 2.51 0 0 0 3.536 0 2.47 2.47 0 0 0 0-3.507 2.5 2.5 0 0 0-1.768-.726",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22 3H2v18h20zM3.481 6.673V4.47H20.52v2.204zm0 1.47V19.53h17.037V8.143z",
    clipRule: "evenodd"
  }));
};
export var BrowserSearch = function BrowserSearch(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: BrowserSearchSvg
  }));
};